import { graphic } from "./Graphic";
import { PanEditionMode } from "./editions/pan/PanEditionMode";

export class ZoomFingers {

    static ZOOM_RATIO = 0.025;

    get countTouches () {
        return Object.keys(this.touches).length;
    }

    constructor() {
        this.touches = {};
        this.isEnable = false
    }

    onStartClick({ detail: { originalEvent: e } }) {
        this.touches[e.data.pointerId] = e;

        if (this.countTouches === 2) {
            graphic.getEditionMode(PanEditionMode).isEnableTranslate = false;
            this.isEnable = true;
        }
    }

    onStopClick({ detail: { originalEvent: e } }) {
        delete this.touches[e.data.pointerId];
        if (e.data.originalEvent.touches && !e.data.originalEvent.touches.length) this.touches = [];

        if (this.countTouches < 2) {
            if (graphic.containEditionMode(PanEditionMode)) {
                graphic.getEditionMode(PanEditionMode).isEnableTranslate = true;
            }
            this.isEnable = false;
        }
    }

    onMoveMouse() {
        if (!this.isEnable) return;

        const identifiers = Object.keys(this.touches);
        const firstTouch = this.touches[identifiers[0]].data.originalEvent.changedTouches[0];
        const secondTouch = this.touches[identifiers[1]].data.originalEvent.changedTouches[1];

        if (!firstTouch || !secondTouch) return;;

        const dist = {
            x: Math.abs(secondTouch.clientX - firstTouch.clientX),
            y: Math.abs(secondTouch.clientY - firstTouch.clientY),
        };
        const total = dist.x + dist.y;

        if (!this.lastDist) {
            this.lastDist = total;
        } else {
            let direction = null;
            if (total > this.lastDist) direction = 1;
            else if (total < this.lastDist) direction = -1;
            if (!direction) return;

            const firstPosition = this.touches[identifiers[0]].data.global;
            const secondPosition = this.touches[identifiers[1]].data.global;

            let center = { x: null, y: null };
            if (firstPosition.x > secondPosition.x) center.x = secondPosition.x + (firstPosition.x / 2);
            else center.x = firstPosition.x + (secondPosition.x / 2);
            if (firstPosition.y > secondPosition.y) center.y = secondPosition.y + (firstPosition.y / 2);
            else center.y = firstPosition.y + (secondPosition.y / 2);

            graphic.setZoom({
                value: graphic.zoom + (ZoomFingers.ZOOM_RATIO * direction),
                round: false,
                origin: graphic.withTransformContainer(graphic.parentCenter)
            });

            this.lastDist = total;
        }
    }
}